import { injectIntl } from 'react-intl'
import { StyledModal } from './StyledModal'
import { useEffect, useState } from 'react'
import ModalFullScreen from '../../modal-full-screen/ModalFullScreen'
import GalleryCarousel from '../../carousel/GalleryCarousel'
import FooterTabs from '../../carousel/FooterTabs'
import StoreNavigation from '../store-navigation/StoreNavigation'

// carousel gallery divided in sections

const GalleryModal = (props: any) => {
    const [isFullScreen, setIsFullScreen] = useState(false)

    const {
        open,
        close,
        photoInSections,
        photoList,
        store,
        carouselState,
        setCarouselState,
        isApp,
        banner,
        storeName,
    } = props

    const tabControl = (pageNumber: number) => {
        setCarouselState({ ...carouselState, page: pageNumber })
    }

    useEffect(() => {
        if (photoList[carouselState.page]) {
            const newSection = photoList[carouselState.page].macroarea
            if (newSection !== carouselState.tab)
                setCarouselState({ ...carouselState, tab: newSection })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carouselState.page])

    return (
        <StyledModal
            isFullScreen={isFullScreen}
            onKeyDown={(e) => {
                if (e.key === 'ArrowLeft') {
                    if (carouselState.page > 0)
                        tabControl(carouselState.page - 1)
                } else if (e.key === 'ArrowRight') {
                    if (carouselState.page < photoList.length - 1)
                        tabControl(carouselState.page + 1)
                }
            }}
            tabIndex={0}>
            <ModalFullScreen
                open={open}
                onHide={close}
                // header={
                //     <StoreNavigation
                //         isModalHeader
                //         storeName={store.name}
                //         storeCode={store.id}
                //     />
                // }
            >
                <GalleryCarousel
                    isApp={isApp}
                    isFullScreen={false}
                    setIsFullScreen={setIsFullScreen}
                    page={carouselState.page}
                    photoList={photoList}
                    tabControl={tabControl}
                    banner={banner}
                    storeName={storeName}
                    close={close}
                    footer={
                        <FooterTabs
                            activeTab={carouselState.tab}
                            photoInSections={photoInSections}
                            onTabChange={(item: any) => {
                                setCarouselState({
                                    page: photoInSections[item].list[0].index,
                                    tab: item,
                                })
                            }}
                        />
                    }
                />
            </ModalFullScreen>
        </StyledModal>
    )
}

export default injectIntl(GalleryModal)

